import { css, cx } from "@emotion/css";
import type { MouseEvent, ReactNode } from "react";
import { LongText } from "src/components/Default/LongText";

export interface DeckChartSegment {
	count: number;
	color: string;
}

interface DeckCircleChartProps {
	segments: DeckChartSegment[];
	total: number;
	title?: string;
	className?: string;
	onClick?: (e: MouseEvent) => void;
	/** Treść w środku koła (domyślnie liczba wszystkich). */
	centerContent?: ReactNode;
	/** Treść pod wykresem. */
	children?: ReactNode;
}

const buildGradient = (segments: DeckChartSegment[], total: number): string => {
	if (total === 0) {
		return "conic-gradient(var(--bgFill2) 0%, var(--bgFill2) 100%)";
	}

	let cumulativePercent = 0;
	const stops: string[] = [];

	for (const segment of segments) {
		if (segment.count <= 0) {
			continue;
		}

		const start = cumulativePercent;
		cumulativePercent += (segment.count / total) * 100;
		stops.push(
			`${segment.color} ${start}%, ${segment.color} ${cumulativePercent}%`,
		);
	}

	return `conic-gradient(${stops.join(", ")})`;
};

export const DeckCircleChart = ({
	segments,
	total,
	title,
	className,
	onClick,
	centerContent,
	children,
}: DeckCircleChartProps) => {
	const gradient = buildGradient(segments, total);

	return (
		<div className={cx(className, "circle-chart")}>
			{title && (
				<LongText className="size-16-light text-ellipsis-1 first-letter-upper">
					{title}
				</LongText>
			)}
			<div
				onClick={onClick}
				className={cx(
					"pie-chart",
					{ "cursor-pointer": !!onClick },
					css`
						background-image: ${gradient};
					`,
				)}
			>
				<span className="size-18">{centerContent ?? total}</span>
			</div>
			{children}
		</div>
	);
};
